import React from "react"
import * as v2layouts from "../layouts"

interface ConfirmationModalProps {
	title: string
	message: string
	confirmText?: string
	cancelText?: string
	onConfirm: () => void
	onCancel: () => void
}

export function ConfirmationModal({
	title,
	message,
	confirmText = "Continue",
	cancelText = "Cancel",
	onConfirm,
	onCancel,
}: ConfirmationModalProps): JSX.Element {
	return (
		<v2layouts.Modal onClick={onCancel}>
			<v2layouts.ModalContent onClick={(e) => e.stopPropagation()}>
				<v2layouts.ModalTitle>{title}</v2layouts.ModalTitle>

				<div style={{ marginBottom: "20px", fontSize: "14px", color: "#616161", lineHeight: "1.6" }}>
					{message}
				</div>

				<v2layouts.ButtonGroup>
					<v2layouts.ActionButton onClick={onCancel}>{cancelText}</v2layouts.ActionButton>
					<v2layouts.ActionButton $variant="primary" onClick={onConfirm}>
						{confirmText}
					</v2layouts.ActionButton>
				</v2layouts.ButtonGroup>
			</v2layouts.ModalContent>
		</v2layouts.Modal>
	)
}
